<template>
  <div>
    <div>
      <tooltip
        text="We try to standardize shipping costs across our patners.
However, you may wish to adjust your prices to reflect your operational realities.
Note that your service costs may appear lower or higher than our standard service cost, subject to your settings.

The shipping prices for the route below has been modified."
      >
        <span>
          <img src="@/assets/images/icons/info.svg" alt="" />
        </span>
      </tooltip>
      <SelectCountry class="mx-2" style="width: 320px" />
      <span>
        <Button
          @click="showRoutes = !showRoutes"
          text="Select Route"
          class="float-right"
        />
      </span>
    </div>
    <b-table-simple
      head-row-variant="primary"
      borderless
      outlined
      responsive="sm"
    >
      <b-thead>
        <b-tr class="" style="background-color: #dae8f6">
          <b-th>Route</b-th>
          <b-th>Date Last Modified</b-th>
          <b-th>Modified By</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr class="b-b" v-for="(route, i) in billingSettings" :key="i">
          <b-td style="border-right: solid 1px #dae8f6">
            {{ getRouteName(route) }}
          </b-td>
          <b-td style="border-right: solid 1px #dae8f6">{{
            route.updatedAt | formatDate
          }}</b-td>
          <b-td style="border-right: solid 1px #dae8f6">{{
            getUser(route)
          }}</b-td>
          <b-td style="border-right: solid 1px #dae8f6; align-item: center">
            <span>
              <el-dropdown>
                <button>
                  <span>
                    <img src="@/assets/images/icons/more.png" alt="" />
                  </span>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    ><span @click="editRouteSetting(route)"
                      >View Pricing Info</span
                    >
                  </el-dropdown-item>
                  <el-dropdown-item
                    ><span @click="editRouteSetting(route)">Edit</span>
                  </el-dropdown-item>

                  <el-dropdown-item
                    ><span @click="simulateCostModal(route)"
                      >Simulate Cost</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown></span
            ></b-td
          >
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <loader v-if="loading"></loader>

    <div v-if="billingSettings == '' && loading === false" class="pa-5 my-5">
      <EmptyState
        class="px-5"
        description="We Try to standardize shipping costs across our patners.
However, you may wish to adjust your prices to reflect your operational realities.
Note that your service costs may appear lower or higher than our standard service cost, subject to your settings.

You are currently using MuleEx Standardized Shipping Prices"
      />
    </div>
    <!-- <pre>{{routes}}</pre> -->
    <!-- Select Route modal -->
    <modal
      @close-modal="showRoutes = false"
      :showModal="showRoutes"
      id="selectRoute"
      width="22.9"
    >
      <div>
        <h4 class="font-weight-bold">Select Route</h4>
        <div class="mx-2">
          <span class="pr-4 mb-n2 opacity-50">
            <search-icon class="mt-3 mb-n3" />
          </span>
          <input
            v-model="search"
            type="search"
            name=""
            placeholder="Search..."
            id=""
            class="pb-1"
          />
          <hr />
          <div class="my-2">
            <b-form-group>
              <template #label>
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="routes"
                  aria-controls="routes"
                  @change="toggleAll"
                >
                  {{ allSelected ? "Un-select All" : "Select All" }}
                </b-form-checkbox>
              </template>
              {{ filterRoutes }}
              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-if="showMore"
                  id="routes"
                  v-model="selectedRoute"
                  :options="filterRoutes"
                  :aria-describedby="ariaDescribedby"
                  name="routes"
                  class=""
                  aria-label="Individual routes"
                  stacked
                >
                </b-form-checkbox-group>
                <b-form-checkbox-group
                  v-else
                  id="routes"
                  v-model="selectedRoute"
                  :options="filterRoutes.slice(0, 4)"
                  :aria-describedby="ariaDescribedby"
                  name="routes"
                  class=""
                  aria-label="Individual routes"
                  stacked
                >
                <template #options>
                  
                </template>
                </b-form-checkbox-group>
              </template>
            </b-form-group>
          </div>
          <Button
            v-if="showMore"
            @click="showMore = false"
            style="color: #fcc210"
            text="View Less Routes"
            background="white"
          />
          <Button
            v-else
            @click="showMore = true"
            style="color: #fcc210"
            text="View All Routes"
            background="white"
          />
          <div class="my-3">
            <Button
              @click="showRoutes = false"
              class="mr-1 float-left"
              text=" Cancel"
              background="white"
            />
            <Button
            :disabled="allSelected.length < 0"
              class="ml-1 float-right"
              text="Next"
              @click="setCostElement"
            />
          </div>
        </div>
      </div>
    </modal>
    <!-- simulate cost modal -->
    <modal
      @close-modal="showModal = false"
      :showModal="showModal"
      id="simulateCost"
      width="40"
    >
      <div class="container">
        <div class="row my-5">
          <div class="col-md-6">
            <span>Etimated Shipping Cost:</span>
          </div>
          <div class="col-md-6">
            <div
              class="border ml-auto"
              style="
                width: 207px;
                height: 44px;
                border-radius: 2px;
                font-size: 24px;
                font-weight: 600;
                margin-right: 0px;
              "
            >
              <span class="ml-5">₦</span>
              <span>{{ estimatedCost.totalCost }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span class="float-left">Select Shipment Type:</span>
          </div>
          <div class="col-md-6" style="padding-right: 0px">
            <div class="col-sm-4 float-right radiobtn">
              <label class="">
                <input
                  type="radio"
                  v-model="simulateCostPayload.shipmentType"
                  name="select_shipment_type"
                  value="light"
                  @change="radioChanged"
                />
                <div
                  class="radioImg border"
                  style="height: 60px; width: 60px; padding: 0px 18px 0px 14px"
                >
                  <svg
                    width="24.06"
                    class="mt-2 radioImg mb-1 mx-auto"
                    height="18.2"
                    viewBox="0 0 21 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.0487 7.90006C13.5271 7.90006 13.0365 7.62233 12.7711 7.17795L10.7868 3.88834L8.80566 7.17795C8.53718 7.62541 8.04652 7.90315 7.52499 7.90315C7.38613 7.90315 7.24726 7.88463 7.11456 7.84451L2.88683 6.63483V12.1278C2.88683 12.5814 3.19542 12.9764 3.63363 13.0844L10.3054 14.7539C10.6202 14.8311 10.9504 14.8311 11.2621 14.7539L17.94 13.0844C18.3782 12.9733 18.6868 12.5783 18.6868 12.1278V6.63483L14.4591 7.84143C14.3264 7.88155 14.1875 7.90006 14.0487 7.90006ZM20.6094 4.43764L19.0201 1.26529C18.9244 1.07397 18.7177 0.962873 18.5048 0.990646L10.7868 1.97506L13.6166 6.66877C13.7339 6.86319 13.9684 6.95576 14.1875 6.89405L20.2946 5.15049C20.6001 5.061 20.7482 4.72155 20.6094 4.43764ZM2.55355 1.26529L0.96429 4.43764C0.822336 4.72155 0.973547 5.061 1.27597 5.1474L7.38304 6.89096C7.60214 6.95268 7.83667 6.8601 7.95394 6.66569L10.7868 1.97506L3.06581 0.990646C2.85288 0.965959 2.64921 1.07397 2.55355 1.26529Z"
                      fill="#8CAFD3"
                    />
                  </svg>
                  <p class="package-text text-center">
                    Light <br />
                    Package
                  </p>
                </div>
              </label>
            </div>
            <div class="col-sm-4 float-right radiobtn">
              <label>
                <input
                  type="radio"
                  v-model="simulateCostPayload.shipmentType"
                  name="select_shipment_type"
                  value="single"
                />

                <div
                  style="height: 60px; width: 60px; padding: 0px 18px 0px 14px"
                  class="border radioImg"
                >
                  <svg
                    width="24.06"
                    class="mt-2 radioImg mb-1 mx-auto"
                    height="18.2"
                    viewBox="0 0 26 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.3798 11.25H20.9076V15L19.5187 14.168L18.1298 15V11.25H14.6576C14.2756 11.25 13.9631 11.5312 13.9631 11.875V19.375C13.9631 19.7188 14.2756 20 14.6576 20H24.3798C24.7617 20 25.0742 19.7188 25.0742 19.375V11.875C25.0742 11.5312 24.7617 11.25 24.3798 11.25ZM7.71311 8.75H17.4353C17.8173 8.75 18.1298 8.46875 18.1298 8.125V0.625C18.1298 0.28125 17.8173 0 17.4353 0H13.9631V3.75L12.5742 2.91797L11.1853 3.75V0H7.71311C7.33116 0 7.01866 0.28125 7.01866 0.625V8.125C7.01866 8.46875 7.33116 8.75 7.71311 8.75ZM10.4909 11.25H7.01866V15L5.62977 14.168L4.24089 15V11.25H0.768663C0.386719 11.25 0.0742188 11.5312 0.0742188 11.875V19.375C0.0742188 19.7188 0.386719 20 0.768663 20H10.4909C10.8728 20 11.1853 19.7188 11.1853 19.375V11.875C11.1853 11.5312 10.8728 11.25 10.4909 11.25Z"
                      fill="#8CAFD3"
                    />
                  </svg>
                  <p class="package-text text-center">
                    Single <br />
                    Package
                  </p>
                </div>
              </label>
            </div>
            <div
              style="padding-right: 0px"
              class="col-sm-4 float-right radiobtn"
            >
              <label>
                <input
                  v-model="simulateCostPayload.shipmentType"
                  type="radio"
                  name="select_shipment_type"
                  value="bulk"
                />
                <div
                  style="height: 60px; width: 60px; padding: 0px 18px 0px 14px"
                  class="border radioImg"
                >
                  <svg
                    width="24.06"
                    class="my-2 radioImg mx-auto"
                    height="18.2"
                    viewBox="0 0 19 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.3272 12.4167C13.9957 12.4167 13.6777 12.285 13.4433 12.0505C13.2089 11.8161 13.0772 11.4982 13.0772 11.1667C13.0772 10.8351 13.2089 10.5172 13.4433 10.2828C13.6777 10.0484 13.9957 9.91666 14.3272 9.91666C14.6587 9.91666 14.9766 10.0484 15.2111 10.2828C15.4455 10.5172 15.5772 10.8351 15.5772 11.1667C15.5772 11.4982 15.4455 11.8161 15.2111 12.0505C14.9766 12.285 14.6587 12.4167 14.3272 12.4167ZM15.5772 4.91666L17.2105 6.99999H13.4939V4.91666H15.5772ZM4.32719 12.4167C3.99567 12.4167 3.67773 12.285 3.44331 12.0505C3.20888 11.8161 3.07719 11.4982 3.07719 11.1667C3.07719 10.8351 3.20888 10.5172 3.44331 10.2828C3.67773 10.0484 3.99567 9.91666 4.32719 9.91666C4.65871 9.91666 4.97665 10.0484 5.21107 10.2828C5.44549 10.5172 5.57719 10.8351 5.57719 11.1667C5.57719 11.4982 5.44549 11.8161 5.21107 12.0505C4.97665 12.285 4.65871 12.4167 4.32719 12.4167ZM15.9939 3.66666H13.4939V0.333328H1.82719C0.902189 0.333328 0.160522 1.07499 0.160522 1.99999V11.1667H1.82719C1.82719 11.8297 2.09058 12.4656 2.55942 12.9344C3.02826 13.4033 3.66415 13.6667 4.32719 13.6667C4.99023 13.6667 5.62611 13.4033 6.09496 12.9344C6.5638 12.4656 6.82719 11.8297 6.82719 11.1667H11.8272C11.8272 11.8297 12.0906 12.4656 12.5594 12.9344C13.0283 13.4033 13.6641 13.6667 14.3272 13.6667C14.9902 13.6667 15.6261 13.4033 16.095 12.9344C16.5638 12.4656 16.8272 11.8297 16.8272 11.1667H18.4939V6.99999L15.9939 3.66666Z"
                      fill="#8CAFD3"
                    />
                  </svg>
                  <p class="package-text text-center">Bulk</p>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Pickup Location
              </label>
              <vue-google-autocomplete
                id="map1"
                ref="shipperAddress"
                :value="simulateCostPayload.takeOffLocation.name"
                classname="input"
                style="width: 207px"
                placeholder="Enter Pickup Location"
                v-on:placechanged="getPickUp"
              >
              </vue-google-autocomplete>
            </span>
          </div>
          <div class="col-md-6">
            <span class="float-right">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Delivery Location
              </label>
              <vue-google-autocomplete
                id="map2"
                ref="shipperAddress"
                :value="simulateCostPayload.dropOffLocation.name"
                classname="input"
                style="width: 207px"
                placeholder="Enter Delivery Location"
                v-on:placechanged="getDelivery"
              >
              </vue-google-autocomplete>
            </span>
          </div>
        </div>
        <div class="row my-5">
          <div class="col-md-6">
            <span class="float-left">
              <label for="dimension" style="font-weight: 400; font-size: 12px"
                >Dimension (cm)
              </label>
              <div>
                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="simulateCostPayload.dimension.length"
                  placeholder="-L-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
                <span class="float-left mt-2" style="color: #cbd2dd">*</span>
                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="simulateCostPayload.dimension.width"
                  placeholder="-W-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
                <span class="float-left mt-2" style="color: #cbd2dd">*</span>

                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="simulateCostPayload.dimension.height"
                  placeholder="-H-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
              </div>
            </span>
          </div>
          <div class="col-md-6">
            <span class="float-right">
              <label for="weight" style="font-weight: 400; font-size: 12px"
                >Weight (kg)
              </label>

              <base-input
                style="width: 207px"
                type="text"
                name="weight"
                v-model="simulateCostPayload.dimension.estimatedWeight"
                placeholder="Weight"
                required="true"
                error="Enter Weight"
              >
              </base-input>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Button
              @click="showModal = false"
              text="Cancel"
              class="float-left"
              background="white"
            />
          </div>
          <div class="col">
            <Button
              :loading="loading"
              @click="simulateCost"
              text="Calculate"
              type="submit"
              style="width: 207px"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/UI/Modal/index.vue";
import BaseInput from "@/components/UI/BaseInput.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import EmptyState from "@/components/UI/EmptyState.vue";
import Button from "@/components/UI/BaseButton.vue";
import SelectCountry from "@/components/UI/CountryDropdown.vue";
import Tooltip from "@/components/UI/Tooltip.vue";

export default {
  components: {
    EmptyState,
    Button,
    VueGoogleAutocomplete,
    Tooltip,
    Modal,
    BaseInput,
    SelectCountry,
  },
  data() {
    return {
      loading: false,

      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
      },

      selectedSimulate: "",

      estimatedCost: 30000,
      selected: [],
      billingSettings: [],
      showMore: false,
      search: "",
      allSelected: false,
      indeterminate: false,
      showModal: false,
      showRoutes: false,
      shipmentPackages: ["light", "heavy", "haulage"],
      routes: [],
      simulateCostPayload: {
        shippingServiceId: "006f3aa0-91ef-44e0-88db-6a7a6a3eec47",
        orgId: "eb62e41a-3387-4cb2-befa-2b5f2a7b2f18",
        dimension: {
          width: null,
          length: null,
          height: null,
          estimatedWeight: null,
        },
        takeOffLocation: {
          name: "",
          lat: 0.0,
          lng: 0.0,
        },
        dropOffLocation: {
          name: "",
          lat: 0.0,
          lng: 0.0,
        },
        shipmentType: "light",
      },
      fields: [
        {
          key: "route",
          label: "Route",
        },
        {
          key: "dateModified",
          label: "Date Modified",
        },
        {
          key: "modifiedBy",
          label: "Modified By",
        },
        {
          key: "menuIcon",
          label: "",
        },
      ],
      selectedRoute: [],
      radioBtnColor: "#8CAFD3",
    };
  },
  mounted() {
    this.getAllRoutes();
    this.getBillingSettings();
    this.$refs.shipperAddress.update(this.formatAddress(this.shipper.address));
  },
  methods: {
    getPickUp(pickUpData) {
      this.simulateCostPayload.takeOffLocation.name = pickUpData.route;
      this.simulateCostPayload.takeOffLocation.lat = pickUpData.latitude;
      this.simulateCostPayload.takeOffLocation.lng = pickUpData.longitude;
    },
    getDelivery(deliveryData) {
      this.simulateCostPayload.dropOffLocation.name = deliveryData.route;
      this.simulateCostPayload.dropOffLocation.lat = deliveryData.latitude;
      this.simulateCostPayload.dropOffLocation.lng = deliveryData.longitude;
    },
    getRouteName(route) {
      return route.shippingService?.routeName
        ? route.shippingService?.routeName
        : "N/A";
    },
    getUser(route) {
      return route.user?.firstname
        ? route.user?.firstname +
            " " +
            route.user?.lastname
        : "N/A";
    },

    simulateCostModal(route) {
      this.showModal = true;
      this.selectedSimulate = route;
    },
    editRouteSetting(e) {
      this.$emit("editRouteSetting", e);
      this.$emit("openEditCostElement");
    },
    setCostElement() {
      this.$emit("setCostElement");
      this.$emit("selectedRoute", this.selectedRoute);
    },
    async simulateCost() {
      try {
        this.loading = true;
        let orgId = localStorage.getItem("organizationId");
        this.simulateCostPayload.orgId = orgId;
        this.simulateCostPayload.shippingServiceId =
          this.selectedSimulate.shippingServiceId;
        let response = await this.$_simulateCost(this.simulateCostPayload);

        this.estimatedCost = response.data.data;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getAllRoutes(params) {
      try {
        let response = await this.$_getAllRoutes(params);
        this.routes = response.data.data.shippingServices
          .filter((route) => route.isIntrastate == true)
          
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async getBillingSettings() {
      try {
        let orgId = localStorage.getItem("organizationId");

        let response = await this.$_getBillingSettings(
          orgId,
          "single",
          "intra"
        );
        this.billingSettings = response.data.data;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    radioChanged() {
      this.radioBtnColor = "#fff";
    },
    toggleAll(checked) {
      this.selectedRoute = checked ? this.routes.slice() : [];
    },
  },
  computed: {
    filterRoutes() {
      return this.filterArray(this.routesFilter, this.search);
    },
    routesFilter(){
      let route = this.routes.filter(x => x.isIntrastate == true && x.routeName).map(route => route.routeName)
      // let parsedRoute = this.parseRouteCities(route)
      return route
    }
  },
  watch: {
    estimatedCost(val) {
      this.estimatedCost = val;
    },
    selectedRoute(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.routes.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
.b-b:nth-of-type(1) {
  border-bottom: 1px solid #dae8f6;
}
.package-text {
  font-size: 8px;
  align-items: center;
  line-height: 10.89px;
}
.radiobtn input:checked + .radioImg {
  background-color: #10233e;
  color: #fff;
}
.radiobtn input:checked + .radioImg svg path {
  fill: #fff;
}
.inputb {
  height: 44px;
  width: 207px;
  padding: 10px 0px 10px 10px;
}
.inputloca {
  height: 44px;
  width: 207px;
  /* padding: 10px 0px 10px 10px; */
}
</style>
